import React, { memo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { formatMoney } from "app/common/LocalFunction";
import { useFormikContext } from "formik";
import { toast } from "react-toastify";

export const optionLg = {
    layout: "vertical", // xếp dọc
    align: "right", // canh bên phải
    verticalAlign: "middle", // căn giữa theo chiều dọc
};

export const optionXs = {
    layout: "horizontal", // xếp dọc
    align: "center", // canh bên phải
    verticalAlign: "bottom", // căn giữa theo chiều dọc
};


const ReportPaymentMethodPieChart = ({ data, isMobile }) => {
    const { values } = useFormikContext();

    // Common render function for custom label
    const renderCustomLabel = (chart, series) => {
        let customLabel = chart.options.chart.custom.label;

        if (!customLabel) {
            customLabel = chart.options.chart.custom.label = chart.renderer
                .label(``)
                .css({
                    color: "#000",
                    textAnchor: "middle",
                    fontSize: `${series.center[2] / 12}px`,
                })
                .add();
        } else {
            customLabel.attr({
                text: ``,
            });
        }

        const x = series.center[0] + chart.plotLeft,
            y = series.center[1] + chart.plotTop - customLabel.getBBox().height / 2;

        customLabel.attr({
            x,
            y,
        });
    };

    function stringToColor(str) {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        const c = (hash & 0x00ffffff).toString(16).toUpperCase();
        return "#" + "00000".substring(0, 6 - c.length) + c;
    }

    const options = {
        credits: {
            enabled: false,
        },
        chart: {
            type: "pie",
            height: "360px",
            custom: {},
            events: {
                render() {
                    const chart = this;
                    const series = chart.series[0];
                    renderCustomLabel(chart, series);

                    document.querySelectorAll(".legend-copy-method").forEach((el) => {
                        el.onclick = () => {
                            const moneyText = el.querySelector(".number-hide")?.innerText || "";
                            const methodText = el.querySelector(".method-name")?.innerText || "";
                            navigator.clipboard.writeText(+moneyText);
                            toast.success(`Đã copy số liệu hình thức ${methodText}`);
                        };
                    });

                    const el = document.querySelector(".chart-title-copy-method");
                    if (el) {
                        el.onclick = () => {
                            const moneyText = el.querySelector(".number-hide")?.innerText || "";
                            navigator.clipboard.writeText(moneyText);
                            toast.success(`Đã copy tổng doanh thu theo HTTT`);
                        };
                    }
                },
            },
        },
        accessibility: {
            point: {
                valueSuffix: "%",
            },
        },
        tooltip: {
            formatter: function () {
                return `
      ${this.key}: 
      <b>${Highcharts.numberFormat(this.percentage, 2)}% 
      (${formatMoney(this.y)})</b>
    `;
            },
        },
        legend: {
            ...(!isMobile ? optionLg : optionXs),
            useHTML: true,
            labelFormatter: function () {
                const percent = Highcharts.numberFormat(this.percentage, 2);
                return `
        <div class="legend-copy-method flex justify-between align-center" style="padding: 4px 0; border-bottom: 1px solid #eee; width: 280px;">
            <span class="method-name" style="font-weight: 600; color: #333;">${this?.name}</span>
            <span class="flex gap-1 align-center">
                <span class="money-number" style="float: right; color: #000;">${formatMoney(
                    this.y || 0
                )}</span>
                <span style="font-size: 12px; color: #999;">${percent}%</span>
                <span class="number-hide">${this.y}</span>
            </span>
        </div>
      `;
            },
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: "pointer",
                borderRadius: 10,
                dataLabels: {
                    enabled: false,
                },
                showInLegend: true,
                innerSize: "25%",
                point: {
                    events: {
                        mouseOver: function () {
                            this.graphic.attr({
                                r: this.shapeArgs.r * 1.1,
                            });
                        },
                        mouseOut: function () {
                            this.graphic.attr({
                                r: this.shapeArgs.r,
                            });
                        },
                    },
                },
            },
        },
    };

    const options1 = {
        ...options,
        title: {
            useHTML: true,
            text: `
      <span class="chart-title-copy-method" style="cursor:pointer;">
        Doanh thu theo HTTT: ${formatMoney(data?.subTotalAmount || 0)}
        <span class="number-hide">${data?.subTotalAmount || 0}</span>
      </span>
    `,
        },
        series: [
            {
                name: "",
                colorByPoint: true,
                data: data?.paymentMethodTotals?.map((el) => ({
                    name: el?.namePaymentMethodValue,
                    y: el?.total,
                    color: stringToColor(el?.namePaymentMethodValue || ""),
                })),
            },
        ],
    };

    return (
        <div style={{ width: "100%", height: "360px" }}>
            <HighchartsReact highcharts={Highcharts} options={options1} />
        </div>
    );
};



export default memo(ReportPaymentMethodPieChart);
